import React, { useState } from "react";
import { Download } from "lucide-react";
import topImg from "../../../assets-user/sideImg.png";
import { downloadFile, formatPrice } from "../../../utils/helpers";

const FloorPlan = ({ floorPlan = [] }) => {
  console.log("Floor plan===>", floorPlan);
  const [downloadingIndex, setDownloadingIndex] = useState(null);
  if (!floorPlan.length) return null;

  const handleDownload = async (plan, index) => {
    if (!plan.floorDesign) return;
    setDownloadingIndex(index);
    await downloadFile(plan.floorDesign, `FloorPlan-${plan.bhk || ""}BHK.pdf`);
    setDownloadingIndex(null);
  };

  return (
    <div className="">
      <div className="bg-white p-4 md:p-6 lg:p-8 rounded-lg border">
        <h2 className="font-poppins font-medium tracking-[0.01em] leading-[150%] text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#031722] mb-1 sm:mb-2 md:mb-3 lg:mb-4">
          Floor Plan
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3 md:gap-4">
          {floorPlan.map((plan, index) => {
            const areaText =
              plan.carpetArea &&
              `${plan.carpetArea?.value} ${plan.carpetArea.unit || "sqft"}`;

            const priceText =
              plan.expectedPrice && formatPrice(plan.expectedPrice);

            return (
              <div
                key={plan._id || index}
                className="bg-white border rounded-lg shadow-md overflow-hidden p-4 hover:shadow-lg transition-shadow"
              >
                <div className="relative overflow-hidden w-full h-auto">
                  <img
                    src={topImg}
                    alt="Floor Layout"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="py-2">
                  {plan.bhk && (
                    <h3 className="font-medium text-[#031722] tracking-[0.01em] text-xs sm:text-base mb-1.5">
                      {plan.bhk} BHK Apartment
                    </h3>
                  )}

                  {(plan.bathrooms || plan.balcony) && (
                    <p className="font-medium text-[#C3C3C3] text-xs sm:text-base mb-1">
                      {areaText}
                    </p>
                  )}

                  {priceText && (
                    <p className="font-semibold text-[#000785] text-xs sm:text-base mb-3">
                      {priceText}
                    </p>
                  )}

                  {plan.floorDesign && (
                    <button
                      onClick={() => handleDownload(plan, index)}
                      disabled={downloadingIndex === index}
                      className={`w-full flex items-center justify-center gap-2 px-4 py-2 border-2 rounded-full transition-colors font-medium tracking-[0.01em] text-[11.02px] border-[#DC2200] ${
                        downloadingIndex === index
                          ? "text-gray-400 cursor-not-allowed"
                          : "text-[#DC2200] hover:bg-orange-50"
                      }`}
                    >
                      {downloadingIndex === index ? (
                        <>
                          <span className="animate-pulse">Downloading...</span>
                        </>
                      ) : (
                        <>
                          <Download size={18} />
                          Download Floor Plan
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FloorPlan;
